import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static values = {
        url: String,
    }

    async connect() {
        const target = this.element;

        target.style.opacity = .5;
        const response = await fetch(this.urlValue);
        target.innerHTML = await response.text();
        target.style.opacity = 1;
    }
}